import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { Children } from 'react';
import ProgressStepperItem from './ProgressStepperItem';
const ProgressStepper = ({ children, className, ...rest }) => {
    const dataAttributes = useDataAttributes(rest);
    return (_jsx("ol", { className: buildClassName('flex flex-row items-start gap-2 p-0', className), ...dataAttributes, children: Children.map(children, (child) => {
            return (_jsxs(_Fragment, { children: [child, _jsx(GeneralIcons.ChevronRightIcon, { "aria-hidden": "true", size: "24px", direction: "right", className: "text-darker-gray self-center last:hidden" })] }));
        }) }));
};
ProgressStepper.Item = ProgressStepperItem;
export default ProgressStepper;
//# sourceMappingURL=ProgressStepper.js.map